import storejs from 'store';
import Vue from 'vue';

async function sha256(message) {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message);

  // hash the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  // convert bytes to hex string
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

export default {
  actions: {
    analyticsEvent(_, { action, category, label, value }) {
      Vue.$gtag.event(action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    },
    async analyticsUpdateUserId(_, userData) {
      const currentUser = userData || storejs.get('currentUser') || '';
      const user_id =
        currentUser === '' ? '' : await sha256(currentUser.username);
      Vue.$gtag.set({ user_id });
    },
    analyticsLogin({ dispatch }) {
      dispatch('analyticsEvent', { action: 'login' });
    },
  },
};
